<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{toggleMenu}">
              <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
                <div :class="['icon24', nativeFilterIconClass]"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox
        v-if="operatorValue == '=' || operatorValue == '!=' || col.formatType == 116"
        v-model="filterValue"
        :displayField="propsData.suffixDisplayField ? propsData.displayField : col.displayField ?? col.dataField"
        :valueField="propsData.suffixDisplayField ? propsData.valueField : col.dataField"
        :suffixDisplayField="propsData.suffixDisplayField"
        v-model:display="displaySuffixValue"
        ref="thEnum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :data="propsData.data"
        :columns="propsData.columns"
        :dropdownWidth="propsData.dropdownWidth"
        :formatType="col.formatType"
        :queryMode="propsData.queryMode"
        @filterGrid="filterSearchGrid"
        @msKeydown="handleKeyDown"
        :filterSeachGrid="col.filterSeachGrid"
        @selected="onSelectedItemCombobox"
        @comboboxLoadData="
          payload =>
            onComboboxLoadData(payload, null, {
              dataField: col.dataField,
              sender: thEnum,
            })
        "
        @keydown.stop=""
        :hasBorder="false"
        :isGridEditor="isGridEditor"
        :is-reload="propsData.isReload"
        @customComboboxEnumData="onCustomComboboxEnumData"
      ></ms-combobox>

      <ms-input
        v-else
        ref="thEnum"
        v-model="filterValue"
        class="ms-input-filter-value"
        @keydown.stop=""
        :hasBorder="false"
      />
    </div>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance, ref} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default defineComponent({
  extends: msThOptionBase,
  components: {MenuItem, MenuWrapper},
  name: 'MsThOptionCombobox',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    propsData: {
      default: {},
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    /**
     * Giá trị hiển thị của filter
     * NXCHIEN 30.05.2023
     */
    const displaySuffixValue = ref();

    //Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
    } = setup(props, {
      emit,
    });

    /**
     * filter table
     * nnninh 07/12/2023
     */
    const filterSearchGrid = value => {
      const {filterSearchComboGrid = false, dataField} = proxy.col;
      // khi search trên grid thì đang mong muốn search theo trường thông tin grid hiển thị: VD: Đối tượng khi hiển thị là accounting_object_name -> search theo accounting_object_name
      if (filterSearchComboGrid) {
        let filterArr = [];
        if (proxy.propsData.columns) {
          proxy.propsData?.columns?.forEach(function (item, index) {
            if (item?.dataField == dataField) {
              filterArr.push({
                field: item.dataField,
                operator: proxy.operatorValue,
                value: value,
              });
            }
          });
        } else {
          filterArr = {
            operator: proxy.operatorValue,
            value: value,
          };
        }
        filterHeaderHandle(filterArr);
      } else {
        filterHeaderHandle({operator: proxy.operatorValue, value: value});
      }
    };

    /**
     * @description: Lắng nghe sự kiện emit từ bên trong dropdown
     * @param: {any}
     * @return: {any}
     * CreatedBy: KBNGUYET 15/05/2024
     */
    const handleKeyDown = (event, instance) => {
      const {filterSearchComboGrid = false} = proxy.col;
      // nếu column cho phép tìm kiếm giá trị ngoài combobox khi nhấn enter
      if (filterSearchComboGrid && (event.key === 'Enter' || event.key === 'Tab') && instance.typeAheadPointer < 0) {
        const inputValue = instance.getValue();
        proxy.filterValue = inputValue;
        filterHeaderHandle({operator: operatorValue, value: inputValue});
      }
    };

    /**
     * Băn sự kiện loadData ra bên ngoài để gọi API
     * dqvinh 23.05.2023
     */
    const onComboboxLoadData = async (payload, row, dataField) => {
      emit('load-filter-header', payload, row, dataField);
    };

    /**
     * @description: Xử lí sự kiện khi chọn item trong combox
     * @param: {any}
     * @return: {any}
     * CreatedBy: KBNGUYET 16/05/2024
     */
    const onSelectedItemCombobox = ({newData}) => {
      let filterArr = [];
      // xử lí trường hợp search với nhiều điều kiện
      // khi chọn item trong combobox filter thì đang mong muốn search theo cả cột hiển thị: VD: đối tượng có cột mã - tên -> search theo cả mã và tên
      // Bổ sung thêm cấu hình cột có chỉ filter theo dataField không phòng TH data k có cột filter ndhieu3 22.11.2024
      if (proxy.propsData.columns && !proxy.col.onlyFilterDataField) {
        proxy.propsData?.columns?.forEach(function (item, undex) {
          // trường hợp nếu giá trị undified thì filter là trống - kbnguyet 23.05.2024
          // nếu trường hợp chọn combobox thì operator luôn là =
          let newValue = newData
            ? proxy.propsData.suffixDisplayField
              ? displaySuffixValue
              : newData[item.dataField]
            : newData;
          filterArr.push({
            field: item.dataField,
            operator: proxy.$ms.constant.FilterOperatorSearch.Equals,
            value: newValue ? newValue : '',
          });
        });
      } else {
        filterArr = {
          operator: proxy.operatorValue,
          value: newData
            ? proxy.propsData.suffixDisplayField
              ? displaySuffixValue
              : newData[proxy.col.dataField]
            : newData,
        };
      }

      filterHeaderHandle(filterArr);
    };

    /**
     * Custom dữ liệu combobox enum ở filter header
     * VDDONG 05/02/2025
     */
    async function onCustomComboboxEnumData(dataRaw, dataAfter, enumName, preThis) {
      emit('customComboboxEnumData', dataRaw, dataAfter, enumName, preThis);
    }

    //Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      thEnum,
      onComboboxLoadData,
      displaySuffixValue,
      filterSearchGrid,
      handleKeyDown,
      onSelectedItemCombobox,
      onCustomComboboxEnumData,
    };
  },
});
</script>
